import { render } from "./UserInformation.vue?vue&type=template&id=164619f2&scoped=true"
import script from "./UserInformation.vue?vue&type=script&lang=js"
export * from "./UserInformation.vue?vue&type=script&lang=js"

import "./UserInformation.vue?vue&type=style&index=0&id=164619f2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-164619f2"

export default script